import { cleanRichTextHtml } from "lib/clean-rich-text-html"
import { normalizeInlineToBlocks } from "lib/normalize-inline-to-blocks"
import { splitBreakSeparatedParagraphs } from "lib/split-break-separated-paragraphs"

/**
 * Single entry point for "stored schedule HTML to FIQ canonical paragraph shape".
 *
 * Editor, preview and comparison all consume the same stored value but legacy
 * delivers it in several shapes (bare inline + <br><br>, single <p> with internal
 * <br> separators, or already block-wrapped). Running each surface through this
 * pipeline guarantees they render the same <p>X</p><p>Y</p> form, so margin-driven
 * paragraph spacing matches everywhere and the round-trip back through
 * `convertDraftForLegacy` is shape-stable.
 */
export function prepareRichTextForRender(html) {
    // Order matters: normalize first (so bare inline content is wrapped in <p>s with internal
    // <br> separators), then split (so each chunk becomes its own <p>), then clean (so the
    // per-paragraph trim/whitespace passes operate on individual blocks rather than one giant
    // <p> hiding intermediate trailing whitespace).
    return cleanRichTextHtml(splitBreakSeparatedParagraphs(normalizeInlineToBlocks(html ?? "")))
}
